import React from 'react';
import {
    Container,
    Paper,
    Box,
    Typography,
    Button,
    Card,
    CardContent
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';

const Login = () => {
    const { login } = useAuth();
    const [searchParams] = useSearchParams();
    
    const handleLogin = () => {
        const redirectUrl = searchParams.get('redirect');
        console.log('Login: redirect parameter:', redirectUrl);
        login(redirectUrl);
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 4
                }}
            >
                <Card elevation={8} sx={{ width: '100%', maxWidth: 400 }}>
                    <CardContent sx={{ p: 4 }}>
                        <Box sx={{ textAlign: 'center', mb: 4 }}>
                            <Typography variant="h4" component="h1" gutterBottom>
                                Welcome to Pulse Restaurant Operation Platform
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Please sign in to access your account
                            </Typography>
                        </Box>

                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            startIcon={<GoogleIcon />}
                            onClick={handleLogin}
                            sx={{
                                py: 1.5,
                                mb: 2,
                                backgroundColor: '#4285f4',
                                '&:hover': {
                                    backgroundColor: '#3367d6',
                                },
                                textTransform: 'none',
                                fontSize: '16px'
                            }}
                        >
                            Sign in with Google
                        </Button>

                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 3 }}>
                            By signing in, you agree to our Terms of Service and Privacy Policy.
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default Login;
